/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_Effectivedate1Inputs */

const id_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Efektif`)
};

const ms_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Berkuat Kuasa`)
};

const da_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikrafttrædelsesdato`)
};

const de_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirksamkeitsdatum`)
};

const en_us2_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effective Date`)
};

const es_es2_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha efectiva`)
};

const es_mx2_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha efectiva`)
};

const fil_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epektibong Petsa`)
};

const fr_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date d'effet`)
};

const it_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data effettiva`)
};

const hu_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hatályos dátum`)
};

const nl_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingangsdatum`)
};

const no_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikrafttredelsesdato`)
};

const pl_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data wejścia w życie`)
};

const pt_br2_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Efetiva`)
};

const pt_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de vigência`)
};

const ro_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data efectivă`)
};

const fi_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voimaantulopäivä`)
};

const sv_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikraftträdandedatum`)
};

const vi_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày hiệu lực`)
};

const tr_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yürürlük Tarihi`)
};

const cs_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum účinnosti`)
};

const bg_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на влизане в сила`)
};

const ru_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата вступления в силу`)
};

const uk_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата набрання чинності`)
};

const ar_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ السريان`)
};

const hi_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रभावी तारीख़`)
};

const th_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่มีผล`)
};

const ja_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`発効日`)
};

const zh_cn2_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生效日期`)
};

const zh_hant1_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生效日期`)
};

const ko_search_sort_effectivedate1 = /** @type {(inputs: Search_Sort_Effectivedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`적용일`)
};

/**
* | output |
* | --- |
* | "Effective Date" |
*
* @param {Search_Sort_Effectivedate1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_sort_effectivedate1 = /** @type {((inputs?: Search_Sort_Effectivedate1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_Effectivedate1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_sort_effectivedate1(inputs)
	if (locale === "ms") return ms_search_sort_effectivedate1(inputs)
	if (locale === "da") return da_search_sort_effectivedate1(inputs)
	if (locale === "de") return de_search_sort_effectivedate1(inputs)
	if (locale === "en-US") return en_us2_search_sort_effectivedate1(inputs)
	if (locale === "es-ES") return es_es2_search_sort_effectivedate1(inputs)
	if (locale === "es-MX") return es_mx2_search_sort_effectivedate1(inputs)
	if (locale === "fil") return fil_search_sort_effectivedate1(inputs)
	if (locale === "fr") return fr_search_sort_effectivedate1(inputs)
	if (locale === "it") return it_search_sort_effectivedate1(inputs)
	if (locale === "hu") return hu_search_sort_effectivedate1(inputs)
	if (locale === "nl") return nl_search_sort_effectivedate1(inputs)
	if (locale === "no") return no_search_sort_effectivedate1(inputs)
	if (locale === "pl") return pl_search_sort_effectivedate1(inputs)
	if (locale === "pt-BR") return pt_br2_search_sort_effectivedate1(inputs)
	if (locale === "pt") return pt_search_sort_effectivedate1(inputs)
	if (locale === "ro") return ro_search_sort_effectivedate1(inputs)
	if (locale === "fi") return fi_search_sort_effectivedate1(inputs)
	if (locale === "sv") return sv_search_sort_effectivedate1(inputs)
	if (locale === "vi") return vi_search_sort_effectivedate1(inputs)
	if (locale === "tr") return tr_search_sort_effectivedate1(inputs)
	if (locale === "cs") return cs_search_sort_effectivedate1(inputs)
	if (locale === "bg") return bg_search_sort_effectivedate1(inputs)
	if (locale === "ru") return ru_search_sort_effectivedate1(inputs)
	if (locale === "uk") return uk_search_sort_effectivedate1(inputs)
	if (locale === "ar") return ar_search_sort_effectivedate1(inputs)
	if (locale === "hi") return hi_search_sort_effectivedate1(inputs)
	if (locale === "th") return th_search_sort_effectivedate1(inputs)
	if (locale === "ja") return ja_search_sort_effectivedate1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_sort_effectivedate1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_sort_effectivedate1(inputs)
	return ko_search_sort_effectivedate1(inputs)
});
export { search_sort_effectivedate1 as "search.sort.effectiveDate" }